<template>
  <button
    :type="type"
    class="border-2 border-gray-100 text-gray-100 rounded-md font-semibold text-lg px-6 py-4 uppercase"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'submit'
    }
  }
}
</script>
